import { ResendVerificationEmailRequest } from "../../main/models/resend-verification-email-request";
import { post } from "./utils";

export const resendVerification = async (request: ResendVerificationEmailRequest) =>
  await post("userAccounts/resend-verification", request);
